import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Switch } from './ui/switch';
import { Image } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DefaultAdToggle = ({ pageId }) => {
  const [showAd, setShowAd] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const response = await axios.get(`${API}/admin/pages/${pageId}`);
        setShowAd(response.data.show_default_ad !== false);
      } catch (error) {
        console.error('Failed to load ad config:', error);
      } finally {
        setLoading(false);
      }
    };
    loadConfig();
  }, [pageId]);

  const handleToggle = async (enabled) => {
    setShowAd(enabled);
    try {
      await axios.put(`${API}/admin/pages/${pageId}`, { show_default_ad: enabled });
      toast.success(enabled ? 'FrostByte ad enabled' : 'FrostByte ad hidden');
    } catch (error) {
      setShowAd(!enabled);
      toast.error('Failed to update ad setting');
    }
  };

  if (loading) return null;

  return (
    <Card className="bg-slate-900 border-slate-800" data-testid="default-ad-config">
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-white font-semibold flex items-center gap-2">
              <Image className="w-5 h-5 text-cyan-400" /> FrostByte Ad
            </h3>
            <p className="text-slate-400 text-sm mt-1">
              Show the default FrostByte IT advertisement in the slideshow rotation.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <span className={`text-sm ${showAd ? 'text-cyan-400' : 'text-slate-500'}`}>
              {showAd ? 'Showing' : 'Hidden'}
            </span>
            <Switch
              checked={showAd}
              onCheckedChange={handleToggle}
              data-testid="default-ad-toggle"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default DefaultAdToggle;
